module.exports = __webpack_public_path__ + "a8a10a3e/img/pwrd-by-sourcery-black.bba9ba41.svg";